import { render, staticRenderFns } from "./plainCTAB.vue?vue&type=template&id=6974650f"
import script from "./plainCTAB.vue?vue&type=script&lang=js"
export * from "./plainCTAB.vue?vue&type=script&lang=js"
import style0 from "./plainCTAB.vue?vue&type=style&index=0&id=6974650f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports